import { Component, computed, input } from '@angular/core';
import { formaterDateNumerique, formaterHeure } from '../../Services/format';

@Component({
  selector: 'app-installation-statut-panel',
  templateUrl: './installation-statut-panel.html',
  styleUrl: './installation-statut-panel.css',
})
export class InstallationStatutPanelComponent {
  readonly statusText = input('');
  readonly statusClass = input('neutral');
  readonly statusColor = input('#6f746f');
  readonly derniereMiseAJour = input<string | null>(null);

  /** Normalise `derniereMiseAJour` ("YYYY-MM-DD HH:mm:ss+TZ") en `Date`, ou `null` si absente/invalide. */
  readonly derniereMiseAJourDate = computed(() => {
    const valeur = this.derniereMiseAJour();
    if (!valeur) return null;
    const date = new Date(valeur.replace(' ', 'T').replace(/([+-]\d{2})$/, '$1:00'));
    return Number.isNaN(date.getTime()) ? null : date;
  });

  readonly jourFormate = computed(() => {
    const date = this.derniereMiseAJourDate();
    return date ? formaterDateNumerique(date) : '—';
  });

  readonly heureFormatee = computed(() => {
    const date = this.derniereMiseAJourDate();
    return date ? formaterHeure(date) : '—';
  });
}
